import { forEach } from "lodash";
import { getAll, removeCookie } from "tiny-cookie";
import moment from "moment";

import sessionApi from "@/api/session";

export default {
  actions: {
    async changeOrganization({ dispatch }, organizationId) {
      // call to service area update
      try {
        await sessionApi.update(organizationId);
        await dispatch("loadSession");
      } catch (e) {
        // Throw error
        console.error(e);
        return;
      }
    },
    async extendSession({ commit, dispatch }) {
      await sessionApi.extendSession();
      commit("setShowSessionDialog", false);
      await dispatch("init");
    },
    async init({ commit, dispatch, getters, state }) {
      await dispatch("loadSession");
      clearInterval(state.intervalId);

      if (!state.loggedIn) {
        commit("setIntervalId", null);
        return;
      }

      const duration = state.expirationCheckInterval;

      const internvalId = setInterval(async () => {
        if (state.loggedIn) {
          const timeToExpiration = getters.getTimeToExpiration(moment.utc());
          state.timeToExpiration = timeToExpiration;

          if (
            timeToExpiration > state.dialogCountdownDuration ||
            timeToExpiration <= 0
          ) {
            return commit("setShowSessionDialog", false);
          } else {
            return commit("setShowSessionDialog", true);
          }
        }
        clearInterval(state.intervalId);
        commit("setLoggedIn", false);
        location.href = "/";
      }, duration);

      commit("setIntervalId", internvalId);
    },
    async loadSession({ commit }) {
      let session;
      try {
        session = await sessionApi.getSession();
      } catch (e) {
        console.error("session error", e);
        return;
      }
      commit("updateSession", session.data);
      return session.data;
    },
    async login({ dispatch }, { password, username }) {
      await sessionApi.login({
        password,
        username,
      });
      await dispatch("init");
    },
    logout({ commit }) {
      const cookieMap = getAll();
      forEach(cookieMap, (val, cookieName) => {
        if (cookieName.startsWith("jwt-valet")) {
          removeCookie(cookieName);
          removeCookie(cookieName, { domain: "ochin.org" });
        }
      });
      commit("setLoggedIn", false);
      location.href = "/login";
    },
  },
  getters: {
    getTimeToExpiration: state => comp => {
      const normalizedExpiration = moment.utc(state.expires * 1000);
      return Math.max(normalizedExpiration.diff(comp), 0);
    },
    getSession: state => {
      return {
        isOchinUser: state.isOchinUser,
        loggedIn: state.loggedIn,
        organizationId: state.organizationId,
        user: state.user,
        username: state.username,
      };
    },
  },
  mutations: {
    setLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    setShowSessionDialog(state, flag = false) {
      state.showSessionDialog = flag;
    },
    setIntervalId(state, id) {
      state.intervalId = id;
    },
    updateSession(state, session) {
      state.expires = session.expires;
      state.isOchinUser = session.user.isOchinUser;
      state.loggedIn = session.loggedIn;
      state.organizationId = session.user.organizationId;
      state.user = session.user;
      state.username = session.username;
      state.serviceArea = session.user.serviceAreaId;
    },
  },
  namespaced: true,
  state: {
    expires: null,
    dialogCountdownDuration: 60000,
    expirationCheckInterval: 500,
    intervalId: null,
    isOchinUser: false,
    loggedIn: false,
    organizationId: null,
    showSessionDialog: false,
    toastRemainingTrigger: 300000,
    toastInterval: 60000,
    timeToExpiration: null,
    user: {},
    username: "",
  },
};
